.mobileAction {
  display: block;

  & p {
    margin: 0;
  }
}
